const hasVehicles = (orderItems: any[]) => {
  return orderItems.some((orderItem) => orderItem.vehicle);
};

export const orderResolvers = {
  ...{ hasVehicles }
};
